export default function (umbrella) {
  var fetch = umbrella.fetch;
  var eventProxyUrl = umbrella.isLocalhost() ? 'https://qa.api.biw.cloud/v1/web-event-proxy' : "https://".concat(window.location.hostname, "/api/v1/web-event-proxy");
  function sendEvent(eventData, topicName) {
    return new Promise(function ($return, $error) {
      var res, data;
      return Promise.resolve(fetch("".concat(eventProxyUrl, "/topics"), {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          eventData: eventData,
          topicName: topicName
        })
      })).then(function ($await_1) {
        try {
          res = $await_1;
          return Promise.resolve(res.json()).then(function ($await_2) {
            try {
              data = $await_2;
              if (res.ok) {
                return $return(data);
              } else {
                return $error(data);
              }
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  umbrella.sendEvent = sendEvent;
}
//# sourceMappingURL=event-proxy.js.map